/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Person_Create_Client_UnavailableInputs */

const fr_person_create_client_unavailable = /** @type {(inputs: Person_Create_Client_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce client n’est plus disponible pour une affectation. Choisissez un client actif ou retirez cette section.`)
};

const en_person_create_client_unavailable = /** @type {(inputs: Person_Create_Client_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This client is no longer available for assignment. Choose an active client or remove this section.`)
};

/**
* | output |
* | --- |
* | "This client is no longer available for assignment. Choose an active client or remove this section." |
*
* @param {Person_Create_Client_UnavailableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const person_create_client_unavailable = /** @type {((inputs?: Person_Create_Client_UnavailableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Person_Create_Client_UnavailableInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_person_create_client_unavailable(inputs)
	return fr_person_create_client_unavailable(inputs)
});